
import { Component } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import MarkerClusterGroup from 'react-leaflet-cluster';
import { Skeleton } from '@mui/material';
import { createMarkerIcon } from '../utils';
import { FullscreenControl } from "react-leaflet-fullscreen";
import "react-leaflet-fullscreen/styles.css";

function Placeholder({ height }) {
   return <Skeleton variant='rectangular' height={height} />
}


function ChangeView({ center, zoom, markers }) {
   const map = useMap();

   if (markers.length === 0)
      map.setView(center, zoom);
   else
      map.fitBounds(markers);
   
   return null;
}

const pinIcon = createMarkerIcon();

const DEFAULT_LAT = -17.8318344;
const DEFAULT_LONG = 31.047353;


export default class MapMarkers extends Component {

   state = {
      center: [ DEFAULT_LAT, DEFAULT_LONG ],
      markers: []
   }

   initialize = () => {

      let lat = 0, long = 0;
      const len = this.props.markers.length;

      if (len > 0) {
         for (const marker of this.props.markers) {
            lat += marker.location.lat;
            long += marker.location.long;
         }

         lat = lat / len;
         long = long / len;
      } else {
         lat = DEFAULT_LAT;
         long = DEFAULT_LONG;
      }

      const center =  [ lat, long ];

      const markers = this.props.markers.map(marker => {
         const { location: { lat, long } } = marker;
         return [ lat, long ];
      })

      this.setState({ center, markers });

   }

   componentDidUpdate(prevProps) {
      // check if props have changed
      if (prevProps.markers !== this.props.markers) {
         this.initialize();
      }
   }

   componentDidMount() {
      this.initialize();
   }

   render() {

      const height = this.props.height || 500;
      const defaultZoom = this.props.defaultZoom || 4;
      
      return <div className='relative p-0 m-0' style={{ height }}>
         <MapContainer
            scrollWheelZoom={false}
            style={{ height }}
            placeholder={<Placeholder height={height} />}
            className='relative'
         >
            <TileLayer
               attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
               url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <MarkerClusterGroup>
               {
                  this.props.markers.map(marker => {
                     const { location: { lat, long }, caption } = marker;
                     const popup = caption ? <Popup>{caption}</Popup> : undefined;

                     return <Marker icon={pinIcon} position={[ lat, long ]}>
                        {popup}
                     </Marker>
                  })
               }
            </MarkerClusterGroup>
            <ChangeView center={this.state.center} markers={this.state.markers} zoom={defaultZoom} />
            <FullscreenControl position="topleft" />
         </MapContainer>
         {
            this.props.markers.length === 0 && <div className='absolute top-0 bottom-0 left-0 right-0 flex items-center justify-center bg-[#000C] z-[5000]'>
               <p className='text-white text-lg'>
                  {this.props.emptyMessage || 'No markers to display'}
               </p>
            </div>
         }
      </div>
   }
}